import {ObjectOfStrings} from '@fo/shared-types';

import i18nKeys from './translations/en.json';

export const getMessages = (): ObjectOfStrings => i18nKeys;
